import GPDto from "../Geschaeftspartner/GPDto";

export default class ZVVMitgliedDto {
  constructor(json) {
    if (json) {
      this.beitrittsdatum = json.beitrittsdatum
      this.austrittsdatum = json.austrittsdatum
      this.isKi = json.isKi
      this.verteilnetzbetreiberName =json.verteilnetzbetreiberName
      this.geschaeftspartner = new GPDto(json.geschaeftspartner)
    }
  }

  get name() {
    return this.geschaeftspartner.name
  }

  get adresse() {
    return this.geschaeftspartner.adresse
  }

  get kanton() {
    return this.geschaeftspartner.kanton
  }

  get ki() {
    return this.isKi ? 'zvv.mitglied.yes' : 'zvv.mitglied.no'
  }
}
